import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { docs } from '@services/docs/docs-service'
import { billing } from '@services/billing/billing-service'
import DocumentList from '@components/documents/document-list'
import toast from 'react-hot-toast'
import { IDocument } from '@interfaces/document'
import Container from '@/components/common/container'

const Dashboard = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [documents, setDocuments] = useState<IDocument[]>([])
  const [searchParams, setSearchParams] = useSearchParams()
  document.title = 'Dashboard'

  // Auto-open Stripe billing portal if query param is present (from failed payment emails)
  useEffect(() => {
    if (searchParams.get('openBilling') === 'true') {
      // Remove the query param to prevent re-triggering
      searchParams.delete('openBilling')
      setSearchParams(searchParams, { replace: true })
      // Open Stripe billing portal
      billing.openStripePortal()
    }
  }, [searchParams, setSearchParams])

  useEffect(() => {
    async function fetchDocs() {
      try {
        setLoading(true)
        const res = await docs.getAll()
        const data = res.data as IDocument[]
        setDocuments(data)
      } catch (err) {
      } finally {
        setLoading(false)
      }
    }
    fetchDocs()
  }, [])

  const onDocumentDeleted = async (publicId: string) => {
    try {
      const res = await docs.deleteByPublicId(publicId)
      if (res.status === 200) {
        const newDocuments = documents.filter((doc: IDocument) => doc.public_id !== publicId)
        setDocuments(newDocuments)
        toast.success('Document deleted successfully')
      }
    } catch (err) {
      console.log(err)
    }
  }

  if (loading) {
    return null
  }

  return (
    <Container>
      <DocumentList documents={documents} onDocumentDeleted={onDocumentDeleted} />
    </Container>
  )
}

export default Dashboard
